const DailyConsumptionSliderMarks: { value: number }[] = [
  {
    value: 0,
  },
  {
    value: 0.25,
  },
  {
    value: 0.5,
  },
  {
    value: 0.75,
  },
  {
    value: 1.0,
  },
  {
    value: 1.25,
  },
  {
    value: 1.5,
  },
  {
    value: 1.75,
  },
  {
    value: 2.0,
  },
  {
    value: 2.25,
  },
  {
    value: 2.5,
  },
  {
    value: 2.75,
  },
  {
    value: 3,
  },
];

export { DailyConsumptionSliderMarks };
